import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { RevealOnScroll } from "./Reveal";

const AUDIENCES = [
  { n: "01", name: "Manufacturers",          desc: "Global makers seeking a considered gateway into Africa's discerning market." },
  { n: "02", name: "Fleet & Corporate",      desc: "Enterprises procuring vehicles at scale with predictable delivery and after-sales support." },
  { n: "03", name: "International Suppliers", desc: "Logistics, warranty and insurance partners aligned with the Maklan standard." },
  { n: "04", name: "Dealership Partners",    desc: "Regional distributors invited to represent Maklan under our shared guidelines." },
];

export default function PartnerWithUs() {
  return (
    <section data-testid="partner-with-us" className="section-y-lg bg-ink border-t border-white/5">
      <div className="container-editorial">
        <div className="grid grid-cols-12 gap-8 md:gap-16 mb-20 md:mb-28 items-end">
          <div className="col-span-12 md:col-span-7">
            <motion.span
              initial={{ scaleX: 0 }} whileInView={{ scaleX: 1 }}
              viewport={{ once: true, amount: 0.6 }}
              transition={{ duration: 1.2, ease: [0.19, 1, 0.22, 1] }}
              className="block h-px bg-[#C5A059] w-14 mb-8 origin-left"
            />
            <div className="overline text-[#C5A059] mb-6">Partner With Maklan</div>
            <RevealOnScroll
              element="h2"
              className="font-display text-5xl md:text-6xl leading-[0.95] tracking-tight"
              lines={["Some doors open", "by <em>invitation</em>."]}
            />
          </div>
          <div className="col-span-12 md:col-span-5 md:col-start-8">
            <p className="editorial-body">
              Maklan is more than a retailer. We are a company that curates trust
              between continents. If your business shares our standard, we would
              like to hear from you.
            </p>
            <Link to="/partner" data-testid="partner-cta" className="btn-editorial btn-editorial-gold mt-8">
              Begin a Conversation <ArrowRight size={14} />
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-14">
          {AUDIENCES.map((a, i) => (
            <motion.div
              key={a.n}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 1.2, delay: i * 0.08, ease: [0.19, 1, 0.22, 1] }}
              className="pb-10 border-b border-white/10"
            >
              <div className="font-display italic text-[#C5A059] text-3xl md:text-4xl">{a.n}</div>
              <div className="mt-6 font-display text-2xl md:text-3xl leading-tight">{a.name}</div>
              <div className="w-10 h-px bg-white/15 my-5" />
              <div className="editorial-body max-w-md">{a.desc}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
